import type { AccessControlProvider } from "@refinedev/core";
import { find } from "lodash-es";
import { UserRoleType } from "utils/types/user.type";

import { useGlobalStore } from "@/store";

/**
 * @todo 应该把action也考虑在内的
 */
export const accessControlProvider = {
  async can({ resource, action, params }) {
    const allResources = [
      "index",
      "admin_dashboard", // Dashboard

      "property_list", // 物件リスト
      "property_buildings", // 物件リスト（下楼栋的管理）
      "property_deliveries", // 物件リスト（下配送者的管理）
      "property_service_associated_lockers", // 物件リスト（下服务关联的锁的管理）
      "property_devices", // 物件リスト（下设备的管理）
      "property_lockers",
      "property_deivces_events", // 见 app.constant.tsx 中的说明
      "property_service_pass_providers", // 物件リスト（下Pass配送事業者の管理）

      "device_list", // デバイスリスト

      "imei", // IMEI リスト
      "imei-events",

      "unlock_record", // 解錠記録

      "users_configure", // アカウント管理
      "users", // ユーザー
      "customers", // カスタマー
      "pass_users", // Pass ユーザー
      "service_management", // 運営ツール
      "service_records", // イベントモニタ
      "eazy_update_delete", // EAZY更新・削除
      "todo_management", // Todoリスト

      // 下面这些都是测试自己在用的;
      "quality_assurance_tool",
      "quality_assurance_tool_dashboard",
      "unlock_record_dashboard",
      "charge-unlock-record",
      "registered-devices",
      "properties-no-amazon",
      "unhealthy-devices",
    ];
    const RolePermissions: Partial<Record<UserRoleType, string[]>> = {
      [UserRoleType.SystemManager]: allResources,
      [UserRoleType.TenantManager]: [
        "index",
        "admin_dashboard", // Dashboard

        "property_list", // 物件リスト
        "property_buildings", // 物件リスト（下楼栋的管理）
        "property_deliveries", // 物件リスト（下配送者的管理）
        "property_service_associated_lockers", // 物件リスト（下服务关联的锁的管理）
        "property_devices",
        "property_lockers",
        "property_deivces_events", // 见 app.constant.tsx 中的说明
        "property_service_pass_providers", // 物件リスト（下Pass配送事業者の管理）
        "pass_users", // Pass ユーザー
        "device_list", // デバイスリスト

        "imei", // IMEI リスト
        "imei-events",

        "unlock_record", // 解錠記録

        "users_configure", // アカウント管理
        "users", // ユーザー

        "service_management", // 運営ツール
        "service_records", // イベントモニタ
        "eazy_update_delete", // EAZY更新・削除
      ],
      // [UserRoleType.FutureRoleC]: ["device_list", "imei", "service_management"], // 角色C：未来角色，访问部分资源（与角色B有交集）
    };

    const { roles } = useGlobalStore.getState();
    const findRole = find(roles, ({ role }: { role: UserRoleType }) =>
      [UserRoleType.SystemManager, UserRoleType.TenantManager].includes(role)
    );

    // 一般角色没有权限访问 admin, 除了 SystemManager 和 TenantManager
    if (!findRole) {
      return { can: false };
    }

    if (findRole && resource && RolePermissions?.[findRole?.role as UserRoleType]?.includes(resource)) {
      return { can: true };
    } else {
      return { can: false };
    }
  },
  options: {
    buttons: {
      enableAccessControl: true,
      hideIfUnauthorized: true,
    },
  },
} satisfies AccessControlProvider;
